/*
 * Birthday timer badge countdown.
 *
 * Drives every [data-spectrum-timer] chip toward its data-timer-end (Unix epoch seconds,
 * a shared fixed end time). Display is adaptive: DD:HH:MM:SS while a day or more remains,
 * HH:MM:SS under a day, MM:SS in the final hour (matching the Figma). On expiry the chip is
 * hidden and its [data-timer-fallback] sibling — the "previous badge if any" — is revealed.
 *
 * Re-queries the DOM each tick so timer chips injected by collection AJAX pagination are
 * picked up without re-init. Idempotent: guarded so multiple script includes run one loop.
 */
(function () {
  'use strict';
  if (window.__spectrumTimerBadge) return;
  window.__spectrumTimerBadge = true;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function format(sec) {
    var d = Math.floor(sec / 86400);
    var h = Math.floor((sec % 86400) / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = Math.floor(sec % 60);
    if (d > 0) return pad(d) + ':' + pad(h) + ':' + pad(m) + ':' + pad(s);
    if (h > 0) return pad(h) + ':' + pad(m) + ':' + pad(s);
    return pad(m) + ':' + pad(s);
  }

  function tick() {
    var now = Date.now() / 1000;
    var chips = document.querySelectorAll('[data-spectrum-timer]');
    for (var i = 0; i < chips.length; i++) {
      var el = chips[i];
      if (el.dataset.timerDone === '1') continue;
      var end = parseInt(el.getAttribute('data-timer-end'), 10);
      if (!isFinite(end)) continue;
      var remaining = end - now;
      if (remaining <= 0) {
        el.dataset.timerDone = '1';
        el.style.display = 'none';
        var container = el.parentNode;
        var fallback = container && container.querySelector('[data-timer-fallback]');
        if (fallback) fallback.removeAttribute('hidden');
        continue;
      }
      var text = el.querySelector('[data-timer-text]');
      if (text) text.textContent = format(remaining);
    }
  }

  function start() {
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
